module.exports = __webpack_public_path__ + "static/media/collectionfiff.dc185633.gif";